/* eslint-disable react/react-in-jsx-scope */
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import AssetRelations from "./AssetRelations";

function DependantSlider({ assetUuid, relationType }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        variant="link"
        className="bg-transparent p-0 text-start text-nowrap"
        onClick={handleShow}
        size="sm"
      >
        {relationType.charAt(0).toUpperCase() + relationType.slice(1)} Assets
      </Button>

      <Offcanvas
        style={{ width: "700px" }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {relationType.charAt(0).toUpperCase() + relationType.slice(1)}{" "}
            Assets
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AssetRelations
            selectedAsset={{ Uuid: assetUuid }}
            relationType={relationType}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default DependantSlider;
